module.exports = __webpack_public_path__ + "img/Debbie_King@1x.57144b99.webp";